type AllRoutes = typeof allRoutes;

// a type that represents all the keys of the allRoutes that are protected e.g "chatbot", "dashboard"
export type ProtectedRouteKeys = {
  [K in keyof AllRoutes]: AllRoutes[K]['protected'] extends true ? K : never;
}[keyof AllRoutes];

//a type that hast all route values that are protected e.g. "/chatbot", "/dashboard"
//is used within an array to check if the route is protected e.g. ["/chatbot", "/dashboard"]
export type ProtectedRoutePaths = {
  [K in keyof AllRoutes]: AllRoutes[K]['protected'] extends true ? AllRoutes[K]['route'] : never;
}[keyof AllRoutes];

export type RoutePath = AllRoutes[keyof AllRoutes]['route'];

const allRoutes = {
  homePage: {
    route: '/',
    protected: false,
  } as const,
  chatbot: {
    route: '/chatbot',
    protected: true,
  } as const,
  login: {
    route: '/login',
    protected: false,
  } as const,
  //   dashboard: {
  //     route: '/dashboard',
  //     protected: true,
  //   } as const,
  qbusiness: {
    route: '/qbusiness',
    protected: true,
  } as const,

  groupManager: {
    route: '/group-manager',
    protected: true,
  } as const,
  contact: {
    route: '/contact',
    protected: false,
  } as const,
  impressum: {
    route: '/impressum',
    protected: false,
  } as const,
  datenschutzerklaerung: {
    route: '/datenschutzerklaerung',
    protected: false,
  } as const,

  navigation: {
    route: '/navigation',
    protected: false,
  } as const,
} as const;

export default allRoutes;
